import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'

export const usePayrollModuleAvailability = (integration?: ItemIntegrationFragment) => {
  const { moduleAvailabilities } = useModuleAvailabilities()

  const isPayrollCategoryIntegration = integration?.category?.name === 'Payroll'
  const hasPayrollModulesAvailable = moduleAvailabilities.some(
    (module) => ['payroll', 'compensations'].includes(module.id) && module.available
  )

  const shouldShowPayrollUpsell = isPayrollCategoryIntegration && !hasPayrollModulesAvailable

  return {
    isPayrollCategoryIntegration,
    hasPayrollModulesAvailable,
    shouldShowPayrollUpsell,
  }
}
